import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'

// 応答本文の Markdown リンク `[Done](status:DONE)` から、チップ表示に使うステータスを取り出す。
//
// ステータスは閉じた5値でフロント側も全パターンを知っているため、本文を走査して `Done` や
// `Doing` を直接拾う方式も技術的には成立する。それでも `wbs:` と同じ明示マークアップに揃える。
// `Review` / `Done` は地の文の英単語としても現れうるため走査では誤検出を避けられず、
// 「エージェントが意図して示したステータス」と「たまたま同じ綴りの語」を区別できないため。
//
// リンクテキスト（`[...]` の中身）は表示に使わない。表示ラベルは enum から
// getWbsItemStatusLabel で引くため、モデルがラベルを書き間違えても画面には出ない。
// この点は WbsItemLinkChip（本文の名称を初期表示に使う）と異なる。
const STATUS_LINK_SCHEME = 'status:'

export const parseWbsItemStatusLinkHref = (
  href: string
): WbsItemStatus | null => {
  if (!href.startsWith(STATUS_LINK_SCHEME)) {
    return null
  }
  const value = href.slice(STATUS_LINK_SCHEME.length)
  // 既知のステータス値に完全一致する場合だけ有効とみなす。一致しない場合は null を返し、
  // 呼び出し側は通常のリンク（またはプレーンテキスト）として描画する（優雅な劣化）。
  return Object.values(WbsItemStatus).find(status => status === value) ?? null
}
